import { GlLink, GlSprintf } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { n__, sprintf } from '~/locale';
import TimeAgoTooltip from '../../../vue_shared/components/time_ago_tooltip.vue?vue3';
export default {
    name: 'ShowEdited',
    components: {
        TimeAgoTooltip,
        GlLink,
        GlSprintf
    },
    props: {
        taskCompletionStatus: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        updatedAt: {
            type: String,
            required: false,
            default: ''
        },
        updatedByName: {
            type: String,
            required: false,
            default: ''
        },
        updatedByPath: {
            type: String,
            required: false,
            default: ''
        }
    },
    computed: {
        completedCount () {
            // The new Work Item GraphQL endpoint returns `completedCount` instead, so added a fallback
            // to it for the work item view
            return this.taskCompletionStatus.completed_count ?? this.taskCompletionStatus.completedCount;
        },
        count () {
            return this.taskCompletionStatus.count;
        },
        hasUpdatedBy () {
            return this.updatedByName && this.updatedByPath;
        },
        showCheck () {
            return this.completedCount === this.count;
        },
        taskStatus () {
            const { completedCount, count } = this;
            if (!count) {
                return undefined;
            }
            return sprintf(n__('%{completedCount} of %{count} checklist item completed', '%{completedCount} of %{count} checklist items completed', count), {
                completedCount,
                count
            });
        }
    }
};
